import { Directive, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { capitalizeLineStarts } from '../shared/clinical-text.util';

@Directive({
  selector: 'textarea[appAutoCapitalize], input[type="text"][appAutoCapitalize]',
  standalone: true,
})
export class AutoCapitalizeDirective {
  constructor(@Optional() @Self() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.applyCapitalization(event.target as HTMLInputElement | HTMLTextAreaElement);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    this.applyCapitalization(event.target as HTMLInputElement | HTMLTextAreaElement);
  }

  private applyCapitalization(
    input: HTMLInputElement | HTMLTextAreaElement | null,
  ): void {
    if (!input || typeof input.value !== 'string') {
      return;
    }

    const start = input.selectionStart;
    const end = input.selectionEnd;
    const newVal = capitalizeLineStarts(input.value);

    if (input.value === newVal) {
      return;
    }

    input.value = newVal;

    if (this.ngControl?.control) {
      this.ngControl.control.setValue(newVal, { emitEvent: false });
    }

    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }
  }
}
